import { View } from "@react-pdf/renderer";
export const Row = ({ children, sx = {} }) => {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        ...sx,
      }}
    >
      {children}
    </View>
  );
};
